import { z } from 'zod';
/**
 * The shape of `user` field inside Telegram WebApp initData.
 * Documented at https://core.telegram.org/bots/webapps#webappuser
 */
export const TelegramWebAppUserSchema = z.object({
    id: z.number().int().positive(),
    first_name: z.string().min(1),
    last_name: z.string().optional(),
    username: z.string().optional(),
    language_code: z.string().optional(),
    is_premium: z.boolean().optional(),
    photo_url: z.string().url().optional(),
});
/**
 * Our own persisted user profile, as returned by the API.
 */
export const UserProfileSchema = z.object({
    id: z.string().uuid(),
    telegramId: z.number().int().positive(),
    firstName: z.string(),
    lastName: z.string().nullable(),
    username: z.string().nullable(),
    languageCode: z.string().nullable(),
    photoUrl: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
